import { useState } from "react";
import MainLayout from "../../components/MainLayout";
import Breadcrumb from "../../components/Breadcrumb";
import { Helmet } from "react-helmet-async";
import "./tnc.css"
interface Section {
  id: string;
  title: string;
  content: React.ReactNode;
}

const sections: Section[] = [
  {
    id: "syarat-ketentuan",
    title: "Syarat & Ketentuan",
    content: (
      <>
        <p>
          Halo! Selamat datang di sodtix.com! Terima kasih telah menggunakan
          Layanan Kami.
        </p>
        <p>
          Mohon luangkan waktu sejenak untuk membaca Syarat & Ketentuan ini
          sebelum menggunakan Layanan Kami. Perjanjian ini merupakan kontrak
          yang mengikat secara hukum, jadi pastikan Anda memahami dengan baik
          Syarat & Ketentuan Layanan berikut sebelum menggunakan Layanan Kami.
          Dengan menggunakan Layanan Kami, Anda menyatakan bahwa Anda telah
          membaca, memahami, dan setuju untuk mematuhi Syarat & Ketentuan
          Layanan yang tercantum dalam Perjanjian ini. Jika Anda tidak setuju
          atau tidak dapat mematuhi Perjanjian ini, Anda tidak diperkenankan
          untuk menggunakan Layanan Kami.
        </p>
      </>
    ),
  },
  {
    id: "pendahuluan",
    title: "Pendahuluan",
    content: (
      <>
        <p>
          Syarat & Ketentuan ini terakhir kali diperbarui pada tanggal 01
          Januari 2025.
        </p>
        <p>
          SOD TIX tersedia (a) melalui Situs Web SOD TIX "www.sodtix.com” di
          mana Anda dapat menemukan, memesan, membeli berbagai Aktivitas yang
          sesuai dengan minat Anda; (b) melalui Situs Web SOD TIX
          "www.sodtix.com” merupakan tempat Anda dapat membuat acara, mengelola
          acara, dan menjual Tiket acara; (c) Layanan Offline kami "Sistem
          Manajemen Tiket" dengan RFID, manajemen Tiket masuk, manajemen
          Sponsor, layanan percetakan Tiket, dan layanan pemasaran; (d) melalui
          "Application Programming Interfaces" yang membangun subsistem terpisah
          yang memiliki fungsi berguna oleh subsistem lain untuk mengakses
          fungsi; (a), (b), (c) dan (d) secara kolektif disebut sebagai "Layanan
          Kami".
        </p>
        <p>
          Layanan Kami dimiliki oleh PT Sahabat Olah Duit ("Perusahaan",
          "Kami"). Sebagai penyedia layanan, Kami akan mengelola transaksi
          pemesanan dan pembayaran untuk Tiket Kegiatan (seperti Acara, Bioskop,
          Tur, dan Atraksi) yang tersedia melalui Layanan Kami. Pemilik dari
          setiap Aktivitas adalah Merchant (misalnya, Promotor Acara, Pemilik
          Acara, Penyelenggara Acara, Operator Tempat, dan sebagainya).
          Sementara itu, orang yang membeli atau mendaftar untuk Tiket Aktivitas
          melalui Layanan Kami disebut Pelanggan (misalnya, pembeli, pengunjung,
          peserta Aktivitas, dan lain-lain). Oleh karena itu, baik Anda membeli
          atau menjual Tiket melalui Layanan Kami, Perjanjian ini mengatur akses
          dan penggunaan Layanan Kami oleh Anda sebagai Pengguna.
        </p>
        <p>
          Kami berhak untuk mengubah, memperbarui, atau memodifikasi
          syarat-syarat ini kapan saja tanpa pemberitahuan sebelumnya. Kami
          menyarankan Anda untuk memeriksa kembali Syarat & Ketentuan ini setiap
          kali Anda menggunakan Layanan Kami agar tetap mengetahui setiap
          perubahan yang terjadi. Sebagai Pengguna, dengan terus menggunakan
          Layanan Kami, tidak ada ketentuan dalam Syarat & Ketentuan ini yang
          akan membatasi atau menghalangi Anda untuk menegakkan atau menikmati
          sepenuhnya hak-hak hukum Anda yang diatur oleh hukum umum Indonesia
          ("hak hukum yang tidak dapat dikecualikan" Anda). Namun, dengan
          demikian, Anda juga setuju untuk mematuhi dan terikat oleh Syarat &
          Ketentuan Layanan ini. Jika Anda tidak setuju dengan persyaratan yang
          ada, Anda tidak diperkenankan menggunakan Layanan Kami. Harap
          diperhatikan:
        </p>
        <ol>
          <li>
            Kami tidak secara rutin menyaring konten dari kesesuaian Aktivitas
            apa pun untuk Pengguna individu.
          </li>
          <li>
            Kami tidak memiliki dan/atau menetapkan Harga Jual Tiket apa pun.
          </li>
          <li>
            Kami tidak mendukung Pengguna atau Aktivitas apa pun dan berhak
            untuk menghapus Aktivitas yang dianggap tidak pantas dari Layanan
            Kami kapan saja dan dengan alasan apa pun.
          </li>
          <li>
            Kami tidak mengkonfirmasi identitas atau kesesuaian Pengguna;
            Pengguna berinteraksi dengan risiko mereka sendiri.
          </li>
          <li>Kami bukan penyelenggara dan/atau promotor acara.</li>
          <li>
            Kami menyediakan platform online untuk memfasilitasi penjualan dan
            pembelian Tiket.
          </li>
          <li>
            Kami bukan merupakan pihak dalam perjanjian antara Pelanggan dan
            Merchant untuk penjualan dan pembelian Tiket menggunakan Layanan
            Kami. Dengan demikian, Kami tidak bertanggung jawab atas Aktivitas,
            Acara, atau Tiket yang dibeli. Pengiriman Tiket adalah tanggung
            jawab Merchant dan Kami tidak dapat menjamin bahwa Merchant akan
            menyelesaikan Transaksi dalam setiap kasus; dan
          </li>
          <li>
            Kami dapat membuat perubahan pada Syarat & Ketentuan ini setiap
            saat. Setiap perubahan yang kami buat akan segera berlaku saat kami
            memposting versi revisi dari Syarat & Ketentuan ini. Jika Anda terus
            menggunakan Layanan Kami, Anda akan menerima Perjanjian baru.
            Perihal tersebut mohon untuk memastikan jika Anda membaca
            pemberitahuan tersebut dengan cermat. Jika Anda tidak setuju dengan
            persyaratan Perjanjian ini atau versi revisi Perjanjian ini, Anda
            diperbolehkan untuk berhenti menggunakan Layanan Kami, termasuk
            menghapus Aktivitas apa pun yang telah Anda posting.
          </li>
        </ol>
      </>
    ),
  },
  {
    id: "syarat-umum",
    title: "Syarat & Ketentuan Umum",
    content: (
      <>
        <ol>
          <li>
            Anda berusia minimal 17 tahun atau lebih. Jika Anda berusia di bawah
            17 tahun, Anda sudah mendapatkan izin dari orang tua atau wali sah
            Anda. Harap bawa Kartu Identitas yang valid untuk membuktikan usia
            Anda.
          </li>
          <li>
            Membeli Tiket dari Layanan Kami berarti Anda menyetujui Syarat &
            Ketentuan.
          </li>
          <li>
            Jika Anda membeli Tiket melalui Layanan Kami, berarti Anda memesan
            Tiket langsung dari Merchant, karena Kami hanya bertindak sebagai
            penyedia layanan untuk memfasilitasi pemesanan Tiket. Meskipun
            demikian, Anda tidak perlu khawatir, karena Kami siap membantu Anda
            dalam berkomunikasi dengan Merchant terkait keluhan atau masalah
            yang mungkin timbul, serta berusaha mencari solusi terbaik untuk
            Anda melalui layanan pelanggan Kami.
          </li>
          <li>
            Meskipun kami akan menggunakan keahlian kami dengan hati-hati dalam
            melakukan layanan, kami tidak memverifikasi, dan tidak menjamin,
            bahwa semua informasi yang diberikan akurat, lengkap, benar atau
            terbaru yang tersedia, dan kami tidak bertanggung jawab atas
            kesalahan apa pun (termasuk penempatan dan kesalahan pengetikan),
            gangguan (baik karena sementara dan/atau sebagian, kerusakan,
            perbaikan atau peningkatan situs atau lainnya), informasi yang tidak
            akurat, menyesatkan atau palsu atau tidak tersampaikannya informasi
          </li>
          <li>
            Semua penjualan Tiket TIDAK DAPAT DIKEMBALIKAN, kecuali jika
            Merchant menyatakan hal lain.
          </li>
          <li>
            Membawa Kartu Identitas asli & yang masih berlaku (tidak difotokopi)
            adalah wajib pada saat penukaran/penukaran e-Tiket Anda.
          </li>
          <li>
            E-Tiket dengan nama yang berbeda dari yang tertulis pada kartu
            identitas tidak akan diterima, kecuali Merchant mengizinkan
            perwakilan (seseorang yang ditunjuk oleh Anda) untuk membawa Surat
            Kuasa yang ditandatangani secara sah dan menunjukkan Kartu Identitas
            mereka yang tercantum dalam surat kuasa .{" "}
          </li>
          <li>
            Voucher/Tiket palsu dilarang oleh undang-undang dan akan dituntut
            secara hukum pidana.
          </li>
          <li>
            Kamera & kamera video tidak diperbolehkan memasuki venue, kecuali
            dinyatakan lain oleh Merchant.
          </li>
          <li>
            Menghubungi Kami: Jika Anda memiliki pertanyaan atau menginginkan
            informasi lebih lanjut mengenai Perjanjian ini, silakan hubungi
            hello@sodtix.com.
          </li>
          <li>
            Menghubungi Anda: Jika kami perlu menghubungi Anda, kami akan
            melakukannya menggunakan nomor telepon atau alamat email yang Anda
            berikan saat pengisian formulir pembelian tiket.
          </li>
          <li>
            Merchant bertanggung jawab penuh atas semua Konten yang telah
            dikirimkan melalui Layanan Kami. Dan Anda menyatakan dan menjamin
            bahwa Anda memiliki semua hak, kuasa, dan wewenang yang diperlukan
            untuk memberikan lisensi di atas dan bahwa semua Konten Pengguna (a)
            tidak melanggar, melanggar, menyalahgunakan atau bertentangan dengan
            hak pihak ketiga mana pun; (b) mematuhi semua undang-undang, aturan
            dan peraturan lokal, negara bagian, provinsi, nasional dan lainnya
            yang berlaku; dan (c) tidak melanggar Syarat & Ketentuan ini.
          </li>
          <li>
            Perubahan Perjanjian ini: Kami dapat membuat perubahan pada Syarat &
            Ketentuan ini setiap saat. Setiap perubahan yang kami buat akan
            segera berlaku saat kami memposting versi revisi dari Syarat &
            Ketentuan ini di Situs Web. Jika Anda terus menggunakan Layanan
            Kami, Anda akan menerima Perjanjian baru, jadi pastikan Anda membaca
            pemberitahuan tersebut dengan cermat. Jika Anda tidak setuju dengan
            persyaratan Perjanjian ini atau versi revisi Perjanjian ini, Anda
            dapat berhenti menggunakan Layanan Kami, termasuk menghapus
            Aktivitas apa pun yang telah Anda posting.
          </li>
        </ol>
      </>
    ),
  },
  {
    id: "layanan-kami",
    title: "Layanan Kami",
    content: (
      <>
        <ul>
          <li>
            Layanan kami tersedia online melalui situs web www.sodtix.com dan
            platform lainnya, baik yang akan tersedia di masa mendatang atau
            tidak.
          </li>
          <li>
            Untuk beberapa transaksi dengan Merchant, Layanan Kami "Sistem
            Manajemen Tiket" juga tersedia secara offline sebagai Ticket Box.
          </li>
          <li>
            Kami juga menyediakan "Application Programming Interfaces" sebagai
            Layanan Kami, yang membangun subsistem terpisah yang memiliki fungsi
            yang berguna oleh subsistem lain untuk mengakses fungsi tersebut.
          </li>
          <li>
            Untuk menggunakan Layanan Kami dan melakukan pembelian, Anda
            setidaknya berusia 17 tahun ke atas. Jika Anda berusia di bawah 17
            tahun, pastikan Anda sudah memiliki izin dari orang tua atau wali
            sah Anda. Dan harap membawa Kartu Identitas yang valid untuk
            membuktikan usia Anda.
          </li>
          <li>
            Untuk beberapa transaksi dengan Merchant, Layanan Kami "Sistem
            Manajemen Tiket" juga tersedia secara offline sebagai Ticket Box.
            Jadi Merchant dapat menjual Aktivitas secara offline dan Pelanggan
            dapat membelinya di tempat.
          </li>
          <li>
            Kami dapat mengubah format dan konten Layanan Kami dari waktu ke
            waktu. Kami berhak untuk memodifikasi, mengubah, mengganti, atau
            menarik Aktivitas atau informasi lain apa pun di Layanan Kami. Anda
            setuju bahwa penggunaan Anda atas Layanan Kami adalah atas dasar
            'sebagaimana adanya' dan 'sebagaimana tersedia' dan atas risiko Anda
            sendiri.
          </li>
          <li>
            Semua Aktivitas yang ditawarkan pada Layanan Kami hanya ditujukan
            kepada orang-orang yang mengakses dan melakukan pembelian di
            Indonesia. Jadi jika Aktivitas di Layanan Kami berlokasi di luar
            Indonesia, Anda harus mempertimbangkan pengaturan perjalanan Anda
            ke/dari Aktivitas karena kecuali jika ini dinyatakan secara tegas
            sebagai bagian dari Aktivitas, karena mungkin tidak termasuk sebagai
            bagian dari pembelian. Dan jika Anda memilih untuk menggunakan
            Layanan Kami untuk melakukan pembelian di luar Indonesia, Anda
            melakukannya atas inisiatif Anda sendiri dan harap dicatat bahwa
            Anda akan membebankan biaya pada diri Anda sendiri atas mata uang
            Indonesia.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "akses-layanan",
    title: "Akses Ke Layanan / Pendaftaran Kami",
    content: (
      <ul>
        <li>
          Sebagai Merchant, Anda harus mendaftar dengan akun SOD TIX Anda untuk
          membuat dan mengelola acara Anda.
        </li>
        <li>
          Sebagai Pelanggan kami, pendaftaran Anda untuk mengakses Admin SOD TIX
          bersifat opsional. Tetapi jika Anda memilih untuk mendaftar maka Anda
          harus mengisi formulir di Layanan Kami. Anda menjamin bahwa informasi
          yang Anda masukkan adalah benar, valid, lengkap dan akurat. Anda akan
          segera memberi tahu kami tentang perubahan apa pun pada informasi
          tersebut (Anda dapat melakukannya dengan memperbarui detail akun Anda
          kapan saja). Informasi pribadi yang Anda berikan kepada kami diatur
          oleh kebijakan privasi kami. Dan Kami berhak untuk menolak pendaftaran
          baru atau membatalkan akun Anda setiap saat (termasuk jika Anda tidak
          memberikan kami alamat email yang valid yang bersifat pribadi untuk
          Anda, atau jika Anda tidak memberikan kami alamat email yang benar
          Nama dan nama keluarga).
        </li>
        <li>
          Jika Anda menerima Perjanjian ini atas nama perusahaan atau badan
          hukum lainnya, Anda menyatakan dan menjamin bahwa Anda memiliki
          wewenang untuk mengikat perusahaan atau badan hukum lain tersebut (dan
          "Anda" merujuk dan berlaku untuk perusahaan tersebut atau badan hukum
          lainnya).
        </li>
        <li>
          Untuk mengaktifkan pendaftaran Aktivitas apa pun, Anda harus menekan
          tombol “terima” dimana hal tersebut menyatakan bahwa Anda telah
          membaca dan menyetujui Persyaratan Layanan ini. Jika Anda gagal
          menyetujui Syarat & Ketentuan ini, Anda tidak akan dapat membuat
          Aktivitas atau mempromosikannya di Situs Kami.
        </li>
        <li>
          Dengan menggunakan Layanan Kami, Anda secara tegas setuju bahwa Anda
          tidak akan mengunduh, menampilkan, atau mengirimkan dengan cara apa
          pun, dan atau membuat konten apa pun yang tersedia untuk umum tidak
          sesuai dengan penggunaan yang diizinkan dari Syarat & Ketentuan
          Layanan Tiket dari Layanan Kami.
        </li>
        <li>
          Pada Layanan Kami, mungkin ada tautan ke situs web yang dikelola oleh
          pihak ketiga ("Situs Eksternal"). Situs Eksternal disediakan untuk
          referensi dan kenyamanan saja. Kami tidak mengoperasikan, mengontrol,
          atau mendukung Situs Eksternal dalam bentuk apa pun. Anda bertanggung
          jawab penuh atas penggunaan Anda atas Situs Eksternal tersebut dan
          disarankan untuk meninjau Persyaratan Layanan Situs Eksternal dengan
          cermat.
        </li>
        <li>
          Untuk setiap Aktivitas yang diajukan dan diterbitkan Merchant, kami
          dapat meninjau atau mengembalikannya dengan alasan apa pun, termasuk
          namun tidak terbatas pada Aktivitas apa pun yang mempromosikan
          aktivitas pornografi atau ilegal. Kami berhak untuk mendiskualifikasi
          Aktivitas apa pun yang, atas kebijakan kami sendiri, tidak mematuhi
          Persyaratan Layanan ini atau lainnya.
        </li>
        <li>
          Anda memahami dan menyetujui bahwa mungkin laman kami sewaktu-waktu,
          tidak dapat diakses atau tidak dapat dioperasikan karena alasan
          tertentu, termasuk, namun tidak terbatas pada: (i) malfungsi peralatan
          atau komunikasi; (ii) pemeliharaan berkala, perbaikan, atau tinjauan
          administratif yang dapat Kami lakukan dari waktu ke waktu; atau (iii)
          penyebab di luar kendali Kami atau yang tidak dapat diduga secara
          wajar oleh Kami.
        </li>
      </ul>
    ),
  },
  {
    id: "konten-pengguna",
    title: "Konten Pengguna",
    content: (
      <ul>
        <li>
          Kami dapat, atas kebijakan kami sendiri, mengizinkan Pengguna untuk
          memposting, mengunggah, menerbitkan, mengirimkan atau mengirimkan
          informasi profil, komentar, pertanyaan, umpan balik, gambar, dan
          konten atau informasi lainnya ("Konten Pengguna"). Konten Pengguna
          harus mencakup semua informasi yang diposting, dikirimkan, atau
          disediakan oleh Pengguna di Layanan Kami sehubungan dengan pembuatan
          atau pemesanan Aktivitas.
        </li>
        <ul>
          <li>
            Anda memiliki persetujuan tertulis dari setiap dan setiap orang
            alami yang dapat diidentifikasi dalam Konten Pengguna untuk
            menggunakan nama atau rupa orang tersebut dengan cara yang
            dimaksudkan oleh Layanan Kami dan Perjanjian ini, dan setiap orang
            tersebut telah membebaskan Anda dari tanggung jawab apa pun yang
            mungkin timbul sehubungan dengan penggunaan tersebut.
          </li>
          <li>
            Anda memiliki persetujuan tertulis dari fotografer atau pemilik lain
            dari setiap gambar yang termasuk dalam Konten Pengguna Anda untuk
            menggunakan gambar tersebut.
          </li>
          <li>
            Kami menggunakan Konten Pengguna Anda sebagaimana dimaksud dalam
            Perjanjian ini dan Layanan Kami tidak akan melanggar hukum apa pun
            atau melanggar hak pihak ketiga mana pun, termasuk namun tidak
            terbatas pada hak kekayaan intelektual dan hak privasi apa pun.
          </li>
          <li>
            Konten Pengguna Anda tidak melanggar hukum, berbahaya, mengancam,
            kasar, melecehkan, menyiksa, memfitnah, vulgar, cabul, memfitnah,
            mengganggu privasi orang lain, kebencian atau ras, etnis atau tidak
            menyenangkan.
          </li>
          <li>
            Kami dapat menggunakan hak atas Konten Pengguna yang Anda diberikan
            berdasarkan Perjanjian ini tanpa kewajiban untuk pembayaran biaya
            atau royalti yang harus dibayar berdasarkan perjanjian perundingan
            bersama atau lainnya.
          </li>
          <li>
            Dan harus diketahui, semua Konten Pengguna dan informasi lain apa
            pun yang Anda berikan kepada kami adalah benar dan akurat.
          </li>
        </ul>
      </ul>
    ),
  },
  {
    id: "activity_published",
    title: "Semua Aaktivitas Yang Dipublikasikan Pada Layanan Kami",
    content: (
      <ul>
        <li>
          Anda, sebagai pengguna kami, mengakui bahwa kami tidak menyaring atau
          menyetujui Konten Aktivitas sebelum memposting. Kami tidak membuat
          pernyataan dan/atau jaminan atas klaim apa pun yang dibuat dalam
          postingan apa pun di ulasan dan komentar, profil pribadi, Aktivitas,
          postingan, deskripsi, panduan, dan papan pesan atau Konten Aktivitas
          apa pun, oleh Merchant mana pun.
        </li>
        <li>
          Anda sebagai pedagang, mengirimkan setiap dan semua postingan, pesan,
          teks, file, gambar, foto, video, suara, atau materi lain yang
          diposting di, dikirimkan melalui, dan tersedia melalui Layanan Kami
          untuk digunakan di Situs, Anda setuju bahwa Kami dapat menggunakan
          nama Anda, atau gambar dan kutipan apa pun yang dikaitkan dengan Anda,
          dan foto, video, atau rekaman audio apa pun dari atau oleh Anda
          seperti yang dijelaskan di sini.
        </li>
        <li>
          Kami sebagai mitra dari beberapa Pedagang berhak atas kebijakan kami
          sendiri untuk TIDAK menggunakan Konten Aktivitas apa pun yang
          dikirimkan. Selain itu, dengan mengirimkan Konten Aktivitas, Anda
          sebagai Penjual:(i) Memahami dan menyetujui bahwa Konten Aktivitas
          dapat dipotong, diedit, dimanipulasi secara elektronik, atau diubah
          untuk digunakan di Situs, tanpa persetujuan atau persetujuan lebih
          lanjut, dan bahwa seluruh Konten Aktivitas digunakan di Situs
          sepenuhnya dalam kebijakan Kami. (ii) Menyatakan bahwa Anda adalah
          penulis asli (atau memiliki tugas tertulis dari semua hak dari
          penulis) dari Konten Aktivitas yang dikirimkan, Anda juga adalah
          satu-satunya pemilik hak cipta dari Konten Aktivitas, Anda adalah
          satu-satunya orang yang digambarkan dalam Konten Aktivitas, dan Anda
          memiliki wewenang penuh untuk memberikan kepada Kami hak-hak yang
          disebutkan di sini. (iii) Memahami dan menyetujui bahwa semua Konten
          Aktivitas harus ditinjau dan diedit oleh Kami sebelum diposting atau
          digunakan oleh kami. Anda selanjutnya mengakui bahwa Kami berhak untuk
          menghapus Konten Aktivitas apa pun dari Situs kapan saja dan untuk
          alasan apa pun atas kebijakan Kami sendiri.
        </li>
        <li>
          Semua Konten Aktivitas adalah tanggung jawab penuh dari orang yang
          berasal dari Konten Aktivitas tersebut. Kami sebagai vendor tidak
          mengontrol dan tidak bertanggung jawab atas Konten Aktivitas yang
          dikirimkan dan bahwa dengan menggunakan Layanan Kami, Anda dapat
          terkena Konten Aktivitas yang menyinggung, tidak senonoh, tidak
          akurat, menyesatkan, atau tidak menyenangkan. Demikian juga, kami
          tidak membuat pernyataan atau jaminan mengenai keakuratan,
          kelengkapan, atau keaslian informasi yang terkandung dalam Konten
          Aktivitas apa pun yang diposting, dikirimkan melalui, dan tersedia
          melalui Layanan Kami. Pengguna Layanan Kami menanggung semua risiko
          yang terkait dengan, penggunaan dan/atau ketergantungan pada Konten
          Aktivitas apa pun, dan/atau representasi yang dibuat di dalamnya.
        </li>
      </ul>
    ),
  },
  {
    id: "activity_and_ticket_sales",
    title: "Aktivitas dan Menjual Tiket",
    content: (
      <>
        <ul>
          <li>
            <strong>Aktivitas Tanggung Jawab Merchant:</strong> Dengan membuat
            Aktivitas menggunakan Layanan Kami, Merchant menawarkan untuk
            menjual atau mendistribusikan, dengan Harga Jual, jika berlaku,
            Tiket bagi Pelanggan untuk menghadiri suatu Aktivitas. Penjual
            bertanggung jawab untuk menjelaskan segala aktivitas atau pembatasan
            Tiket kepada Pelanggan dan Penjual bertanggung jawab penuh atas
            semua Aktivitas yang mereka posting di Layanan Kami. Setiap
            perubahan pada Aktivitas dan Tiket harus diberitahukan kepada
            Pelanggan sesegera mungkin.
          </li>
          <li>
            <strong>Representasi Aktivitas:</strong> Aktivitas adalah
            representasi hukum yang dibuat oleh Penjual tentang detail yang
            relevan dengan Tiket dan keakuratan Konten Aktivitasnya.
          </li>
          <li>
            <strong>Preferensi Biaya Layanan:</strong> Penjual harus memilih
            apakah Biaya Layanan harus dibayar oleh Pelanggan, selain Harga
            Jual, atau termasuk dalam Harga Jual dan dibayar oleh Penjual.
          </li>
          <li>
            <strong>Detail Aktivitas:</strong> Merchant harus memberikan semua
            informasi Aktivitas, termasuk:
            <ul>
              <li>nama Aktivitas dan pelaku (jika relevan);</li>
              <li>tanggal Kegiatan;</li>
              <li>lokasi Kegiatan;</li>
              <li>nama, alamat dan wilayah Tempat;</li>
              <li>deskripsi Kegiatan;</li>
              <li>
                gambar yang terkait dengan acara, menggunakan setidaknya
                1024x768 piksel yang tidak lebih besar dari 1 MB;
              </li>
              <li>
                email contact person yang bertanggung jawab atas kegiatan
                tersebut;
              </li>
              <li>jenis Tiket (mis. duduk, berdiri, masuk berwaktu, dll.);</li>
              <li>Harga Jual setiap Tiket;</li>
              <li>kebijakan pengembalian dana, jika ada;</li>
              <li>
                setiap informasi tambahan, aturan, atau persyaratan khusus yang
                berlaku untuk Aktivitas dan/atau Tiket (misalnya, batasan usia,
                batasan aksesibilitas, tampilan terbatas, bagian keluarga,
                batasan alkohol, dll.);
              </li>
            </ul>
          </li>
          <li>
            <strong>Kepatuhan:</strong> Saat membuat Aktivitas, Penjual harus
            mematuhi semua hukum dan peraturan lokal, nasional, dan
            internasional yang berlaku serta ketentuan Perjanjian ini. Jika Anda
            adalah Pedagang yang berdagang sebagai bisnis, Anda harus
            mengidentifikasi diri Anda sendiri dengan menggunakan Akun Bisnis.
            Pedagang yang berdagang sebagai bisnis bertanggung jawab untuk
            mematuhi semua hukum dan peraturan lokal, nasional, dan
            internasional yang berlaku sehubungan dengan kewajiban mereka
            sebagai "pedagang". Kami tidak bertanggung jawab atas kepatuhan
            Merchant terhadap hukum, aturan, atau regulasi yang berlaku.
          </li>
          <li>
            <strong>Jaminan Merchant:</strong> Merchant menyatakan dan menjamin
            untuk dan untuk kepentingan Layanan Kami, bahwa setiap Aktivitas
            yang dia buat:
            <ul>
              <li>
                hanya terkait dengan Tiket dan Aktivitas yang dikontrol oleh
                Merchant, baik secara langsung maupun tidak langsung, dan di
                mana Merchant berada. diizinkan untuk menjual atau
                mendistribusikan Tiket;
              </li>
              <li>
                mencantumkan harga Tiket dan informasi yang akurat dan
                transparan terkait semua biaya tambahan yang akan dikeluarkan
                oleh Pelanggan;
              </li>
              <li>
                tidak melanggar hak pihak ketiga (termasuk hak kekayaan
                intelektual);
              </li>
              <li>
                tidak terdaftar oleh Merchant yang bertindak sebagai perantara,
                agen persewaan, atau agen Aktivitas untuk pihak ketiga;
              </li>
              <li>
                tidak terdiri dari konten yang sama atau secara substansial sama
                dengan Aktivitas lainnya di Layanan Kami;
              </li>
              <li>
                tidak dengan cara apa pun mengandung informasi yang curang atau
                tidak akurat atau menyesatkan;
              </li>
              <li>tidak memfitnah, kasar, mengancam atau cabul;</li>
              <li>
                tidak etis atau diskriminatif berdasarkan usia, jenis kelamin,
                ras, status perkawinan, kebangsaan atau budaya, keyakinan agama
                atau pribadi, kecacatan, orientasi seksual, pendapat politik,
                atau lainnya;
              </li>
              <li>
                jangan mencoba meminta Pengguna mana pun untuk menggunakan
                layanan pihak ketiga yang bersaing dengan Layanan Kami;
              </li>
              <li>
                tidak melanggar hukum atau peraturan lokal, nasional, atau
                internasional yang berlaku, termasuk yang terkait dengan
                pemberian sumbangan amal;
              </li>
              <li>
                tidak mengandung virus atau program lain yang mengganggu atau
                berusaha mengganggu sistem komputer atau data apa pun;
              </li>
              <li>
                tidak dapat ditafsirkan terkait dengan organisasi teroris mana
                pun;
              </li>
              <li>
                tidak mengandung kampanye politik, ajakan komersial, surat
                berantai, surat massal atau segala bentuk "spam".
              </li>
            </ul>
          </li>
          <li>
            <strong>PPN:</strong> Merchant bertanggung jawab untuk memastikan
            bahwa Harga Jual sudah termasuk semua pajak yang diwajibkan atas
            Aktivitas, termasuk PPN atau pajak lokal yang berlaku. Jika ragu,
            Merchant harus meminta saran dari ahli pajak untuk menentukan pajak
            mana yang perlu dipungut dari Pelanggan.
          </li>
          <li>
            <strong>Asuransi:</strong> Merchant bertanggung jawab penuh atas
            asuransi apa pun yang mungkin diperlukan sehubungan dengan
            Aktivitas.
          </li>
          <li>
            <strong>Pembatalan atau Perubahan Acara:</strong> Jika suatu Acara
            dibatalkan, dijadwalkan ulang, atau diubah dengan cara apa pun, hal
            ini harus ditangani oleh Penjual dan dikomunikasikan dengan jelas
            kepada Pelanggan. Aktivitas harus diperbarui atau dihapus oleh
            Merchant dan jika tidak, kami berhak menghapus Aktivitas dari
            Layanan Kami.
          </li>
          <li>
            Kami tidak menjamin bahwa Aktivitas yang dilakukan melalui Layanan
            Kami akan dipublikasikan dan aktif dalam waktu tertentu setelah
            Penjual memposting Aktivitas atau aktivitas tersebut akan muncul
            dalam urutan tertentu dalam hasil pencarian atau bahwa Tiket akan
            dijual. Jika Tiket tidak terjual, Kami tidak bertanggung jawab.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "harga_dan_pembayaran",
    title: "Harga dan Pembayaran untuk Kegiatan Apapun",
    content: (
      <ul>
        <li>
          Kami selalu berusaha menawarkan harga Tiket terbaik untuk setiap
          Kegiatan.
        </li>
        <li>
          Semua harga pada setiap Aktivitas yang kami tawarkan adalah dalam mata
          uang Rupiah (IDR).
        </li>
        <li>
          Tiket yang kami tawarkan di Layanan Kami bergantung pada persyaratan
          tertentu yang dipenuhi dan mungkin memiliki Persyaratan Layanan khusus
          yang menyertainya. Kami bukan pemasok di bawah penawaran, pemasok
          penawaran akan menjadi Merchant. Kami akan menerbitkan semua Aktivitas
          yang Anda beli atas nama Merchant dan Merchant akan bertanggung jawab
          penuh untuk menyediakan Penawaran. Merchant telah setuju dengan kami
          bahwa ia akan menyediakan Aktivitas yang Anda beli melalui Layanan
          Kami.
        </li>
        <li>
          Harga Tiket sebagaimana dikutip pada Layanan Kami dari waktu ke waktu.
          Harga sudah termasuk PPN, jika berlaku. Harga dapat berubah
          sewaktu-waktu.
        </li>
        <li>
          Saat Anda memesan Tiket, Anda harus melakukan pembayaran dalam batas
          waktu yang ditentukan untuk Aktivitas yang kami tawarkan di Layanan
          Kami. Jika pembayaran tidak dilakukan dalam waktu yang ditentukan,
          pesanan Anda akan menjadi tidak valid atau dibatalkan.
        </li>
        <li>
          Pembayaran untuk semua pesanan harus dilakukan dengan kartu kredit
          atau debit Anda harus mengikuti prosedur yang dinyatakan oleh kami
          atau penyedia layanan pembayaran terkait. Singkatnya, Anda harus
          menyadari bahwa transaksi pembayaran online tunduk pada pemeriksaan
          validasi oleh penerbit kartu Anda dan kami tidak bertanggung jawab
          jika penerbit kartu Anda menolak untuk mengotorisasi pembayaran karena
          alasan apa pun. Harap dicatat, penerbit kartu Anda mungkin membebankan
          biaya penanganan online atau biaya pemrosesan. Kami tidak bertanggung
          jawab untuk ini.
        </li>
        <li>
          Harga dibuat dalam jumlah dan mata uang yang tertera belum termasuk
          biaya bank.
        </li>
        <li>
          Jika ada kesalahan penetapan harga yang jelas sehubungan dengan
          penawaran yang dapat secara wajar dikenali oleh Anda sebagai kesalahan
          penetapan harga, maka kami berhak untuk membatalkan pembelian Tiket
          yang diterbitkan sehubungan dengan Penawaran tersebut dan memberikan
          pengembalian uang kepada Anda sehubungan dengan sama.
        </li>
        <li>
          Kami berhak untuk mengubah harga produk sewaktu-waktu tanpa
          pemberitahuan sebelumnya, kecuali produk Anda telah dibeli dan
          menerima surat konfirmasi dari kami.
        </li>
        <li>
          Untuk setiap transaksi yang berhasil, kami akan mengirimkan surat
          konfirmasi melalui email berisi deskripsi Aktivitas dan pemesanan yang
          Anda buat serta konfirmasi pembayaran. Kami akan mengirimkannya
          setelah pembayaran Anda berhasil. Pada email kami akan memberikan
          Tiket elektronik (e-ticket), (i) jika Anda memesan dari website kami
          maka Anda mendapatkan e-Tiket dalam bentuk file PDF; (ii) jika Anda
          memesannya dari layanan kami yang lain maka Anda akan mendapatkan
          e-Tiket sesuai dengan prosedur yang disepakati Merchant untuk
          Aktivitas tersebut.
        </li>
        <li>
          Anda bertanggung jawab untuk membawa dan menyimpan informasi yang
          terdapat pada Tiket yang kami kirimkan. Karena Tiket adalah dokumen
          yang sangat penting dan harus Anda bawa saat akan menukarkan Tiket.
          Kami atau Merchant berhak untuk menolak menyediakan produk atau
          layanan, jika Anda tidak dapat membuktikan bahwa Anda telah melakukan
          pemesanan dan penyelesaian secara sah.
        </li>
      </ul>
    ),
  },
  {
    id: "pembelian_tiket",
    title: "Pembelian Tiket",
    content: (
      <>
        <h4>Hubungan Anda dengan Merchant</h4>
        <ul>
          <li>
            Penting untuk dicatat bahwa Merchant, bukan kami, yang membuat dan
            memiliki Aktivitas. Oleh karena itu, jika Anda memiliki keluhan
            tentang kualitas Aktivitas, keluhan Anda terletak pada Merchant,
            bukan Kami, meskipun kami akan tetap senang mendengar tanggapan Anda
            sehingga kami dapat memutuskan apakah akan melanjutkan penawaran
            Aktivitas dari Merchant tersebut di masa mendatang atau tidak. Kami
            tentu saja menggunakan upaya wajar kami untuk membantu Anda
            memberikan ulasan kepada Merchant jika Anda permintaan: Hubungi
            kami.
          </li>
          <li>
            Karena kontrak Anda tidak dengan kami, tetapi dengan Merchant, kami
            dapat memberikan rincian pemesanan penting kepada Merchant tersebut
            (ingat, mereka bukan bagian dari perusahaan kami, tetapi merupakan
            pihak ketiga yang kami bertindak sebagai agen). Penempatan pesanan
            untuk membeli Tiket akan merupakan persetujuan kepada kami untuk
            memberikan rincian Anda untuk ini.
          </li>
        </ul>
        <h4>Tiket</h4>
        <ul>
          <li>
            Untuk Aktivitas yang Anda bayarkan, Anda akan menerima Tiket
            elektronik (e-Tiket) dan Konfirmasi Keberhasilan Pembayaran dalam
            bentuk file PDF pada e-mail yang Anda gunakan untuk mendaftar. Namun
            untuk Aktivitas tertentu tergantung kesepakatan dengan Merchant,
            e-Tiket Anda yang valid akan menjadi apa yang Merchant kami kirimkan
            ke email Anda sebagai Tiket valid yang dapat Anda gunakan.
          </li>
          <li>
            Anda dapat membeli Aktivitas yang kami tawarkan di situs web kami.
            Dan pada beberapa transaksi dengan Merchant, Anda juga dapat membeli
            Aktivitas yang Anda inginkan di Kotak Tiket kami untuk Tiket
            offline, atau layanan lainnya.
          </li>
          <li>
            Tiket harus digunakan pada tanggal Aktivitas yang ditunjukkan pada
            Tiket, atau Tiket tidak akan berlaku lagi (dan Anda tidak berhak
            atas pengembalian uang).
          </li>
          <li>
            Tiket dapat dibatasi hingga jumlah maksimum. Anda akan diberitahu
            tentang ini pada saat pembelian.
          </li>
          <li>
            Anda bertanggung jawab untuk memeriksa Tiket Anda seolah-olah Anda
            telah membuat kesalahan, hal tersebut tidak selalu dapat diperbaiki
            setelah pembelian. Silakan periksa Tiket Anda pada tanda terima
            dengan hati-hati dan Hubungi Kami segera sebelum Aktivitas jika ada
            kesalahan, atau jika Anda belum menerima Tiket Anda.
          </li>
        </ul>
        <h4>Proses Pembelian</h4>
        <ul>
          <li>
            Tiket dapat dibeli dengan mengklik Aktivitas yang ingin Anda beli
            dan kemudian mengikuti petunjuk yang akan muncul di layar. Anda
            dapat memeriksa dan memperbaiki kesalahan input apa pun dalam
            pesanan Anda hingga Anda mengirimkan pesanan Anda kepada kami.
          </li>
          <li>
            Setelah dikirimkan, pesanan Anda merupakan penawaran kepada kami
            untuk Membeli Tiket. Semua pesanan tunduk pada penerimaan oleh kami.
            Kami tidak berkewajiban untuk menerima pesanan Anda dan dapat,
            menurut kebijaksanaan kami, menolak untuk menerima pesanan apa pun.
            Jika kami menerima pesanan Anda, kami akan mengonfirmasi penerimaan
            tersebut kepada Anda dengan mengirimkan email yang mengonfirmasi
            bahwa kami telah menerima pesanan Anda dan memberikan rincian Tiket
            Anda. Terlepas dari penerimaan kami, kami dapat segera menghentikan
            atau menangguhkan Pembelian (dan menangguhkan atau membatalkan
            Tiket) jika kemudian rincian pembayaran Anda ditemukan tidak valid
            atau kekurangan dana oleh penyedia pembayaran kami, atau kami atau
            penyedia pembayaran kami secara wajar mencurigai perilaku penipuan
            yang terkait dengan akun Anda.
          </li>
          <li>
            Dilarang memperbanyak, menjual, menjual kembali, atau
            memperdagangkan Tiket. Jika Anda mencoba melakukan ini, kami berhak
            untuk membatalkan Tiket dan membatalkan akun Anda. Namun, kami
            mendorong Anda untuk Membeli Tiket dan memberikannya sebagai hadiah!
          </li>
        </ul>
        <h4>Ketentuan tambahan</h4>
        <ul>
          <li>
            Tiket Anda tetap menjadi milik Merchant dan merupakan lisensi
            pribadi yang dapat dibatalkan yang dapat ditarik dan penerimaan
            ditolak kapan saja setelah mengembalikan harga pembelian yang
            dicetak.
          </li>
          <li>
            Merchant kami dapat melarang kami untuk mengeluarkan pertukaran atau
            pengembalian uang setelah Pembelian dilakukan, atau untuk Tiket yang
            hilang, dicuri, rusak atau hancur. Anda bertanggung jawab untuk
            menjaga keamanan Tiket Anda, baik dalam format Tiket digital atau
            kertas. Tidak selalu mungkin untuk mengeluarkan Tiket duplikat. Jika
            duplikat diterbitkan, biaya administrasi yang wajar dapat dikenakan.
          </li>
          <li>
            Kami dapat membatasi jumlah Tiket yang dapat Anda beli untuk
            Aktivitas yang kami tawarkan. Kami berhak, dengan kecurigaan yang
            wajar, untuk membatalkan tanpa pemberitahuan atau kewajiban kepada
            Anda setiap pesanan untuk Tiket yang dibeli melebihi batas yang
            ditentukan atau jika kami secara wajar mencurigai adanya tindakan
            penipuan sehubungan dengan pembelian tersebut.
          </li>
          <li>
            Tiket tidak boleh digunakan untuk iklan, promosi, kontes, atau
            undian tanpa persetujuan tertulis dari Penjual dan Kami.
          </li>
          <li>
            Tiket dijual tunduk pada hak Pedagang untuk mengubah atau
            memvariasikan program karena peristiwa atau keadaan di luar kendali
            wajarnya tanpa wajib mengembalikan uang atau menukar Tiket selain
            dari dalam kasus tertentu yang ditetapkan dalam kebijakan
            pengembalian uang kami.
          </li>
          <li>
            Tempat tersebut dapat menolak atau mencabut izin masuk jika Anda
            atau tamu Anda melanggar Persyaratan Layanan dari Aktivitas atau
            Merchant, atau dengan alasan yang wajar. Setiap upaya untuk menerima
            pendatang yang terlambat akan dilakukan pada jeda yang sesuai dalam
            Kegiatan, tetapi penerimaan tidak dapat dijamin. Pemegang Tiket
            hanya dapat meninggalkan dan memasuki kembali suatu tempat selama
            Kegiatan atas kebijaksanaan Penjual atau manajemen tempat tersebut.
            Anda hanya berhak atas tempat duduk sesuai dengan yang tertera pada
            Tiket, tetapi Penjual berhak menyediakan tempat duduk alternatif
            dari yang tertera pada Tiket.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "kebijakan_pembatalan_pengembalian",
    title: "Kebijakan Pembatalan dan Pengembalian",
    content: (
      <>
        <p>
          Kami bertindak sebagai platform perantara untuk pembelian Tiket.
          Keputusan dan proses pengembalian dana sepenuhnya ditentukan oleh
          Merchant. Meskipun kami memfasilitasi komunikasi dan koordinasi,
          tanggung jawab atas pengembalian dana sepenuhnya berada di pihak
          Merchant. Berikut adalah panduan umum mengenai pembatalan dan
          pengembalian dana saat menggunakan Layanan kami.
        </p>
        <ul>
          <li>
            Sebelum menyelesaikan transaksi pembayaran, pastikan Anda telah
            meninjau detail pemesanan dengan cermat. Semua penjualan tiket
            bersifat final dan tidak dapat diubah, dibatalkan, atau dikembalikan
            kecuali dinyatakan dalam keadaan tertentu sebagaimana dijelaskan di
            bawah ini.
          </li>

          <li>
            <p>
              Dengan menggunakan Layanan kami, Anda mengakui bahwa keputusan dan
              kebijakan pengembalian dana ditetapkan oleh Merchant. Kami hanya
              akan membantu memfasilitasi permintaan pengembalian dana Anda
              sesuai dengan kebijakan Merchant.
            </p>
            <ol>
              <li>
                Jika kami menemukan kesalahan dalam harga Tiket yang Anda pesan,
                kami akan melakukan upaya yang wajar untuk memberi tahu Anda
                sesegera mungkin dan mengizinkan Anda untuk mengubah pesanan
                Anda dengan harga yang benar (mengkredit atau mendebit akun Anda
                sebagaimana berlaku) atau membatalkan pesanan Anda. Jika Anda
                memilih untuk membatalkan, Anda akan menerima pengembalian dana
                penuh dari kami jika Anda sudah membayar. Jika kami tidak dapat
                menghubungi Anda, ini akan dianggap sebagai pembatalan dan
                pengembalian dana akan diberikan.
              </li>

              <li>
                Jika Aktivitas yang kami tawarkan kepada Anda dibatalkan atau
                ada perubahan material pada detail Aktivitas, kami akan
                memberikan pengembalian dana penuh kepada Anda sebesar harga
                nominal yang dibayarkan atau jika nilai nominal telah dikurangi
                oleh Merchant, nilai nominal yang didiskon. Perubahan material
                adalah perubahan yang menurut pendapat wajar kami, membuat
                Aktivitas berbeda secara material dan menyebabkan perubahan
                signifikan dengan apa yang secara wajar dapat diharapkan oleh
                pembeli Tiket, yang diambil secara umum. Misalnya, penggunaan
                pemain pengganti dalam pertunjukan teater bukan merupakan
                perubahan materi.
              </li>

              <li>
                Jika suatu Aktivitas dijadwal ulang (dan Anda tidak dapat
                menghadiri tanggal yang dijadwalkan ulang), kami akan
                berkoordinasi dengan Merchant tentang bagaimana Tiket Anda akan
                diperlakukan namun pengembalian dana dalam kasus ini tidak
                dijamin dan tunduk pada kebijakan Merchant.
              </li>

              <li>
                Ketentuan pengembalian dana tambahan yang spesifik untuk acara
                akan ditetapkan oleh Merchant. Kami hanya bertindak sebagai
                platform untuk memfasilitasi pengaturan tersebut.
              </li>
            </ol>
          </li>
          <li>
            Proses refund akan memakan waktu yang berbeda untuk setiap Bank yang
            Anda gunakan. Untuk informasi detil, silahkan hubungi kami di
            hello@sodtix.com.
          </li>

          <li>
            Untuk setiap Tiket yang direfund, akan dikenakan biaya refund
            sebesar Rp15.000 (Lima Belas Ribu Rupiah).
          </li>

          <li>
            <p>
              Pengembalian dana adalah sejumlah uang yang akan Anda terima
              setelah membatalkan pemesanan yang dapat dikembalikan dananya yang
              Anda buat menggunakan Layanan Kami. Semua pengembalian dana akan
              diproses dan hanya akan diberikan kepada orang yang melakukan
              pembayaran (Pembeli). Untuk memproses refund Anda, Anda harus
              mengikuti Prosedur Refund Kami seperti:
            </p>
            <ol>
              <li>
                Mengisi formulir refund dengan data yang valid, akurat dan
                lengkap oleh Anda sebagai pembeli Tiket.
              </li>

              <li>
                Permintaan pengembalian dana Anda dapat diproses jika Anda telah
                mengisi formulir pengembalian dana dengan data yang valid,
                akurat dan lengkap. Jika formulir Anda tidak lengkap dan akurat
                maka Anda harus mengirimkan kembali Formulir Pengembalian Dana.
              </li>

              <li>
                Setelah pengembalian dana disetujui, dan kami telah
                mengembalikan uang Anda, Tiket Anda tidak berlaku lagi.
              </li>
            </ol>
          </li>
          <li>
            <p>Pembebasan Tanggung Jawab</p>
            <ol>
              <li>
                Dengan membeli tiket melalui Layanan kami, Anda setuju untuk
                mematuhi kebijakan pengembalian dana Merchant. Pengembalian dana
                diproses sepenuhnya atas kebijakan Merchant, dan kami tidak
                bertanggung jawab atas keterlambatan atau masalah yang timbul
                dari jadwal atau prosedur Merchant.
              </li>

              <li>
                Kami hanya bertindak sebagai platform untuk memfasilitasi
                pemesanan tiket dan komunikasi antara Pembeli dan Merchant. Anda
                dengan ini melepaskan kami dari kewajiban langsung untuk
                mengeluarkan pengembalian dana atau menangani sengketa terkait
                pembatalan atau perubahan detail acara.
              </li>

              <li>
                Pengembalian dana, persetujuan, dan waktu proses sepenuhnya
                ditentukan oleh Merchant. Kami tidak bertanggung jawab atas
                masalah apa pun yang timbul dari kebijakan pengembalian dana
                Merchant.
              </li>
            </ol>
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "perlindungan_data_data_pribadi",
    title: "Perlindungan Data & Data Pribadi Anda",
    content: (
      <>
        <p>
          Penggunaan informasi pribadi Anda yang dikirimkan melalui Layanan Kami
          diatur oleh kebijakan privasi kami. Kami dapat menggunakan semua
          informasi yang Anda berikan kepada kami dalam pembelian Tiket/Produk
          (seperti nama, alamat, alamat email, nomor telepon, dll.) Anda untuk
          tujuan:
        </p>
        <ul>
          <li>menyelesaikan transaksi;</li>
          <li>Analisis statistik;</li>
          <li>
            mengirimi Anda berita tentang Aktivitas, penawaran, promosi, dan
            buletin khusus kami baik melalui pos, email, SMS, atau melalui
            jejaring sosial apa pun;
          </li>
          <li>riset pasar.</li>
        </ul>
      </>
    ),
  },
  {
    id: "hak_kekayaan_intelektual",
    title: "Hak dan Kekayaan Intelektual",
    content: (
      <ul>
        <li>
          Semua hak kekayaan intelektual (yang mencakup hak seperti hak cipta,
          dan hak atas merek dagang) dalam setiap konten Layanan Kami (termasuk
          teks, grafik, perangkat lunak, foto, dan gambar, video, suara, merek
          dagang, dan logo lainnya) dimiliki oleh kami dan/atau pemberi lisensi
          kami. Kecuali secara tegas diatur dalam Syarat & Ketentuan ini, tidak
          ada dalam Syarat & Ketentuan ini yang memberi Anda hak apa pun
          sehubungan dengan kekayaan intelektual apa pun yang dimiliki oleh kami
          atau pemberi lisensi kami dan Anda mengakui bahwa Anda tidak
          memperoleh hak kepemilikan apa pun dengan mengunduh konten dari
          Layanan Kami. Jika Anda mencetak, menyalin, atau menyimpan halaman
          dari Layanan Kami (hanya sebagaimana diizinkan oleh Syarat & Ketentuan
          Layanan ini), Anda harus memastikan bahwa hak cipta, merek dagang,
          atau pemberitahuan hak kekayaan intelektual lainnya yang terkandung
          dalam konten asli direproduksi.
        </li>
        <li>
          Anda setuju bahwa Anda tidak boleh mengunggah, memposting,
          mereproduksi, atau mendistribusikan konten apa pun pada atau melalui
          Layanan Kami yang dilindungi oleh hak cipta atau hak kepemilikan
          lainnya dari pihak ketiga, tanpa memperoleh izin dari pemilik hak
          tersebut. Setiap konten berhak cipta atau hak milik lainnya yang
          didistribusikan pada atau melalui Layanan Kami dengan persetujuan
          pemiliknya harus berisi pemberitahuan hak cipta atau hak kepemilikan
          lainnya yang sesuai. Pengiriman atau distribusi yang tidak sah dari
          konten yang memiliki hak cipta atau konten kepemilikan lainnya adalah
          ilegal dan dapat membuat Anda bertanggung jawab secara pribadi atau
          tuntutan pidana.
        </li>
        <li>
          Anda setuju bahwa dengan mengirimkan posting, gambar, atau konten lain
          apa pun untuk dipublikasikan di Layanan Kami (Konten Pengguna), Anda
          mempertahankan hak cipta apa pun yang mungkin Anda miliki di Konten
          Pengguna, namun Anda memberi kami dan afiliasi kami hak yang abadi,
          tidak dapat dibatalkan, mendunia, non-eksklusif, hak dan lisensi bebas
          royalti dan sepenuhnya dapat disublisensikan untuk menggunakan,
          mereproduksi, mengedit, memodifikasi, mengadaptasi, menerbitkan,
          menerjemahkan, membuat karya turunan dari, mendistribusikan,
          menampilkan, dan menampilkan konten tersebut (seluruhnya atau
          sebagian) dan/atau untuk menggabungkannya ke dalam karya lain dalam
          bentuk, media, atau teknologi apa pun, baik untuk tujuan komersial
          maupun non-komersial. Anda melepaskan hak moral apa pun yang mungkin
          Anda miliki, atau untuk diidentifikasi sebagai penulis konten.
        </li>
        <li>
          Anda bertanggung jawab penuh atas Konten Pengguna (termasuk konten
          yang Anda bagikan dengan situs lain, seperti situs jejaring sosial)
          dan kami tidak mendukung Konten Pengguna atau pendapat, rekomendasi,
          atau saran apa pun yang diungkapkan di dalamnya, dan kami secara tegas
          menolak setiap dan semua kewajiban sehubungan dengan dengan Konten
          Pengguna.
        </li>
      </ul>
    ),
  },
  {
    id: "international_users",
    title: "Pengguna Internasional",
    content: (
      <p>
        Situs ini dikendalikan, dioperasikan dan dikelola oleh Kami di
        Indonesia. Kami tidak membuat pernyataan bahwa materi di Situs sesuai
        atau tersedia untuk digunakan di lokasi lain di luar Indonesia. Jika
        Anda mengakses Situs ini dari lokasi di luar Indonesia, Anda bertanggung
        jawab untuk mematuhi semua hukum dan peraturan setempat. Dan harap
        dicatat bahwa Anda akan membebankan biaya pada mata uang Indonesia.
      </p>
    ),
  },
  {
    id: "external_links",
    title: "Link Eksternal",
    content: (
      <p>
        Layanan kami dapat berubah, dari waktu ke waktu, termasuk link ke situs
        eksternal. Kami telah menyertakan tautan ke situs-situs ini untuk
        memberi Anda akses ke informasi dan layanan yang mungkin berguna atau
        menarik bagi Anda. Kami tidak bertanggung jawab atas konten dari
        situs-situs ini atau atas apa pun yang disediakan oleh mereka dan tidak
        menjamin bahwa mereka akan terus tersedia. Fakta bahwa kami menyertakan
        tautan ke situs eksternal tersebut tidak menyiratkan dukungan atau
        hubungan apa pun dengan operator mereka.
      </p>
    ),
  },
  {
    id: "service_standards",
    title: "Standar Layanan Kami",
    content: (
      <>
        <p>
          Kami menjamin bahwa kami akan melakukan perawatan dan keterampilan
          yang wajar dalam melaksanakan kewajiban kami berdasarkan Syarat &
          Ketentuan ini. Asalkan kami telah melakukannya, kami tidak akan
          bertanggung jawab atas kesalahan atau kelalaian, meskipun kami,
          bagaimanapun, mengeluarkan kredit dan pengembalian uang dalam keadaan
          terbatas (lihat bagian Kebijakan Pembatalan & Pengembalian Uang Kami).
          Jika terjadi kesalahan atau kelalaian, kami akan menggunakan upaya
          yang wajar untuk memperbaiki kesalahan atau kelalaian sesegera mungkin
          setelah kami mengetahuinya.
        </p>
        <p>
          Kecuali sebagaimana dinyatakan secara tegas dalam Syarat & Ketentuan
          ini, semua jaminan, ketentuan, atau ketentuan lain, baik tersurat
          maupun tersirat oleh undang-undang atau hukum umum atau sebaliknya
          dikecualikan sejauh diizinkan oleh hukum. Ini tidak menghentikan Anda
          untuk menggunakan hak hukum Anda di bawah hukum umum sejauh kami tidak
          dapat mengecualikannya secara sah, atau mengklaim pemulihan apa pun
          yang mungkin menjadi hak Anda berdasarkan hukum umum.
        </p>
      </>
    ),
  },
  {
    id: "our_responsibility",
    title: "Tanggung Jawab Kami",
    content: (
      <>
        <p>
          Tidak ada dalam Syarat & Ketentuan ini yang membatasi atau
          mengecualikan kewajiban kami kepada Anda: untuk kematian atau cedera
          pribadi yang disebabkan oleh kelalaian kami; untuk misrepresentasi
          yang curang; atau untuk kewajiban lain yang mungkin tidak, menurut
          hukum Indonesia, dibatasi atau dikecualikan.
        </p>
        <p>
          Tunduk pada hal ini, dalam keadaan apa pun kami tidak akan bertanggung
          jawab kepada Anda atas kerugian bisnis apa pun (dan hilangnya
          keuntungan akan selalu diperlakukan sebagai jenis kerugian bisnis) dan
          tanggung jawab apa pun yang kami miliki atas kerugian yang Anda derita
          akibat Pembelian tidak akan melebihi 100% dari jumlah keseluruhan yang
          dibelanjakan untuk Pembelian Tiket yang relevan. Selanjutnya, tanggung
          jawab kami kepada Anda atas setiap dan semua kerugian yang timbul
          sehubungan dengan Syarat & Ketentuan ini (termasuk Pembelian apa pun)
          sangat terbatas pada kerugian yang dapat diperkirakan secara wajar.
          Kerugian dapat diperkirakan di mana mereka dapat dipertimbangkan oleh
          Anda dan kami pada saat pesanan Anda diterima oleh kami.
        </p>
        <p>
          Selain yang secara tegas dijelaskan dalam Syarat & Ketentuan ini, Kami
          tidak menjamin dan mengecualikan semua tanggung jawab sehubungan
          dengan, atau untuk menyediakan, Aktivitas di mana Tiket dapat
          ditukarkan, termasuk yang berkaitan dengan kualitas, keamanan,
          kegunaan, atau aspek lain apa pun dari Aktivitas yang terkait dengan
          penukaran Tiket atau dapat ditukarkan. Namun, kami menerbitkan kredit
          dan pengembalian uang dalam keadaan terbatas (lihat bagian Kebijakan
          Pembatalan & Pengembalian Uang Kami).
        </p>
        <p>
          Kami tidak akan bertanggung jawab atau bertanggung jawab atas
          kegagalan atau keterlambatan dalam kinerja, kewajiban kami yang
          disebabkan oleh peristiwa di luar kendali wajar kami. Di mana video
          ditampilkan, video tersebut dimaksudkan untuk sepenuhnya mewakili
          artis atau Aktivitas. Pengalaman Anda yang sebenarnya mungkin berbeda.
        </p>
      </>
    ),
  },
  {
    id: "indemnification",
    title: "Indemnifikasi",
    content: (
      <>
        <p>
          Dengan menggunakan Layanan Kami, Anda setuju untuk membebaskan kami,
          termasuk direktur, pejabat, karyawan, agen, dan perwakilan kami, dari
          segala klaim, tanggung jawab, kerugian, biaya, dan pengeluaran
          (termasuk biaya hukum) yang timbul akibat tindakan atau kelalaian
          Merchant, termasuk namun tidak terbatas pada:
        </p>
        <ul>
          <li>
            <strong>Pelanggaran Hukum yang Berlaku:</strong> Jika Merchant gagal
            mematuhi hukum, peraturan, atau persyaratan hukum yang relevan
            (misalnya, perizinan, izin usaha, standar keselamatan), yang
            mengakibatkan klaim hukum, denda, atau kerugian.
          </li>
          <li>
            <strong>Pelanggaran Syarat dan Ketentuan:</strong> Jika Merchant
            melanggar Syarat & Ketentuan dalam perjanjian ini (misalnya, tidak
            memberikan acara sebagaimana dijanjikan), yang menyebabkan kerugian
            atau bahaya bagi peserta atau pihak ketiga, kami tidak bertanggung
            jawab.
          </li>
          <li>
            <strong>Kelalaian Berat atau Perilaku Sengaja:</strong> Jika
            Merchant atau perwakilannya bertindak dengan kelalaian berat
            (misalnya, gagal mengambil tindakan yang wajar) atau melakukan
            kesalahan yang disengaja, dan hal ini menyebabkan klaim atau
            kerugian.
          </li>
          <li>
            <strong>Ketidaksesuaian Aktivitas:</strong> Jika Aktivitas
            dibatalkan, diubah secara signifikan, atau tidak memenuhi ekspektasi
            yang diiklankan, dan Anda atau pihak lain mengalami kerugian sebagai
            akibatnya, kami tidak bertanggung jawab.
          </li>
          <li>
            <strong>Cedera Pribadi atau Kerusakan Properti:</strong> Jika acara
            tersebut mengakibatkan cedera pribadi, kerusakan properti, atau
            kerugian lainnya kepada Anda atau pihak lain akibat tindakan atau
            kelalaian Merchant.
          </li>
          <li>
            <strong>Pelanggaran Hak Kekayaan Intelektual:</strong> Jika Merchant
            melanggar hak kekayaan intelektual pihak lain (misalnya, menggunakan
            musik, gambar, atau merek dagang yang dilindungi tanpa izin), yang
            mengakibatkan tuntutan hukum dari pihak manapun.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "penangguhan_penghentian",
    title: "Penagguhan dan Penghentian",
    content: (
      <p>
        Kami dapat menangguhkan atau menghentikan semua atau sebagian dari
        penggunaan Anda atas Layanan kami, akun Anda dan/atau Tiket yang Dibeli
        jika Anda menggunakan (atau mengizinkan siapa pun selain Anda untuk
        menggunakan) Layanan kami, akun Anda, atau Tiket yang Dibeli dengan
        melanggar Syarat & Ketentuan ini dan kami tidak secara wajar menganggap
        bahwa pelanggaran Anda dapat diselesaikan, atau jika dapat diselesaikan,
        Anda telah gagal menyelesaikannya dengan kepuasan wajar kami setelah
        kami meminta Anda untuk melakukannya dan memberi Anda kesempatan yang
        wajar untuk melakukannya. Pengakhiran tidak akan mengurangi hak atau
        pemulihan apa pun yang mungkin Anda atau kami miliki sehubungan dengan
        hak yang masih harus dibayar (termasuk hak sehubungan dengan pelanggaran
        apa pun) atau kewajiban yang timbul sebelum pengakhiran.
      </p>
    ),
  },
  {
    id: "hubungi_kami",
    title: "Hubungi Kami",
    content: (
      <p>
        Silakan ajukan pertanyaan Anda tentang Syarat & Ketentuan ini, pesanan
        yang telah Anda buat atau beli secara umum melalui email ke
        hello@sodtix.com atau kirim surat kepada kami di Rawa Papan Residence,
        Jl. H. Leman No.139 A, RW.6, Bintaro, Pesanggrahan, Jakarta Selatan,
        Jakarta 12330.
      </p>
    ),
  },
];

export default function TermCondition() {
  const [activeSection, setActiveSection] = useState<string | null>(null);

  // Scroll to a specific section
  const handleLinkClick = (id: string) => {
    setActiveSection(id);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <MainLayout>
      <Helmet>Syarat & Ketentuan</Helmet>
      <Breadcrumb
        label="Syarat & Ketentuan"
        breadcrumbs={[
          { label: "Home", href: "/" },
          { label: "Syarat & Ketentuan", href: "#" },
        ]}
      />
      <div className="container-tnc">
        {/* Links on the top, above the content */}
        <div className="links-tnc">
          {sections.map((section) => (
            <a
              key={section.id}
              href={`#${section.id}`}
              onClick={(e) => {
                e.preventDefault();
                handleLinkClick(section.id);
              }}
              className={`link-tnc ${activeSection === section.id ? "active" : ""}`}
            >
              {section.title}
            </a>
          ))}
        </div>

        {/* Right-side content */}
        <div className="content-tnc">
          {sections.map((section) => (
            <div
              id={section.id}
              key={section.id}
              className={`section-tnc ${
                activeSection === section.id ? "highlight" : ""
              }`}
            >
              <h2>{section.title}</h2>
              {section.content}
            </div>
          ))}
        </div>
      </div>
    </MainLayout>
  );
}
